import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";

interface WizardStepWifiProps {
  wifiSSID: string;
  wifiPassword: string;
  processing: boolean;
  loading: boolean;
  onSSIDChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onConfigure: () => void;
  onBack: () => void;
}

export function WizardStepWifi({
  wifiSSID,
  wifiPassword,
  processing,
  loading,
  onSSIDChange,
  onPasswordChange,
  onConfigure,
  onBack,
}: WizardStepWifiProps) {
  return (
    <div className="p-fluid">
      <div className="p-field">
        <h3>Configure WiFi</h3>
        <p>Enter WiFi credentials to configure the device:</p>

        <div className="p-field" style={{ marginTop: "24px" }}>
          <label htmlFor="wifi-ssid">WiFi Network Name (SSID)</label>
          <InputText
            id="wifi-ssid"
            name="wifi-ssid"
            autoComplete="off"
            value={wifiSSID}
            onChange={(e) => onSSIDChange(e.target.value)}
            disabled={processing || loading}
            className="p-mb-3"
            style={{ marginBottom: "16px" }}
          />
        </div>

        <div className="p-field">
          <label htmlFor="wifi-password">WiFi Password</label>
          <Password
            inputId="wifi-password"
            name="wifi-password"
            autoComplete="new-password"
            value={wifiPassword}
            onChange={(e) => onPasswordChange(e.target.value)}
            feedback={false}
            toggleMask
            disabled={processing || loading}
            className="p-mb-4"
            style={{ marginBottom: "24px" }}
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "16px",
          }}
        >
          <Button
            label="Configure WiFi"
            icon="pi pi-wifi"
            onClick={onConfigure}
            disabled={processing || loading || !wifiSSID || !wifiPassword}
            className="p-button-primary"
            style={{ width: "100%", marginBottom: "10px" }}
          />
          <Button
            label="Back"
            icon="pi pi-arrow-left"
            onClick={onBack}
            className="p-button-secondary"
            disabled={processing || loading}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}
